import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { PageContext } from "../../../../Context/PageContext";
import VipRequestForm from "./VipRequestForm";
import { OpenPopMenu } from "../../../../PopMenuWindow/PopMenuWindow";
import PopUpImg from "../img/wallpaper_60_1024.png"

function VipRequestRules(){

    const { user, setPopMenuContent, setDashboardPageSelection } = useContext(PageContext);

    const [submitButtonColor, setSubmitButtonColor] = useState("rgba(112, 118, 113, 0.5)");
    const [availableSubmit, setAvailableSubmit] = useState("none");

    function rulesValidationCheck(event){

        if(event.target.checked === false) {
            setSubmitButtonColor("rgba(112, 118, 113, 0.5)");
            setAvailableSubmit("none");
            return;
        } else { 
            setSubmitButtonColor("rgba(28, 160, 46, 1)");
            setAvailableSubmit("auto");
        };
        return;
    }

    return(
        <MasterContainer>
        <VipRequestMaster>
            <TitleMaster>
                <h1>Solicitação de acesso Vip</h1>
                <span>Para prosseguir com a sua solicitação de <b>Doação</b> e ativação do período <b>Vip</b>,<br/>
                Leia as instruções e preencha os campos solicitados abaixo.<br/><br/>
                <b>Atenção:</b> Leias todas as regras abaixo, e caso esteja de acordo, prossiga para solicitação do seu acesso Vip.<br/>
                </span>
            </TitleMaster>
            
            <RuleMaster>
                <Legend>Regras</Legend>

            <Clause> <b>1.1</b> - Ragnarok Online e todos os produtos relacionados <b>são de propriedade da Gravity e seus criadores originais</b>. LionsRagnarok Private Server é uma <b>releitura do jogo oficial, tendo suas próprias configurações e filosofia, não possuíndo qualquer vínculo oficial</b> com a empresa criadora do game. É um projeto feito de fãs para fãs.</Clause>

            <Clause> <b>1.2</b> - LionsRagnarok Private Server <b>não cobra pelo acesso padrão ao servidor</b>, sendo este de forma 100% gratuita.</Clause>

            <Clause> <b>1.3</b> - Todas as <b>Doações</b> ao servidor são <b>atos 100% voluntários</b>. É através das doações que o projeto se mantém, cobrindo todos os custos envolvidos na manutenção de um servidor de jogos.
            </Clause>

            <Clause> <b>1.4</b> - As <b>Doações sob nenhuma hipótese são reimbolsáveis</b>. Como forma de agradecimento pela Doação, é concedido o período Vip ao acesso selecionado, de acordo com o plano selecionado no momento da doação. Ao realizar uma Doação, o usuário expressamente concorda com a condição de não-reembolso, ciente de que o período VIP é concedido como um brinde pelo seu apoio voluntário ao projeto.
            </Clause>

            <Clause> <b>1.5</b> - A realização da <b>Doação e a posse do período Vip</b> não isentam o usuário de quaisquer Regras de uso do servidor, não sendo isentos das puniçõe previstas e informadas (incluindo o banimento permanente dos acessos e da conta), caso o usuário inflija qualquer uma das regras correntes.
            </Clause>

            <Clause> <b>1.6</b> - A utilização de programas maliciosos como bots e outros softwares de terceiros não autorizados para acesso ao servidor será punida com <b>BANIMENTO PERMANENTE de todos os acessos da conta, mesmo nos casos em que o período Vip esteja ativo, </b> não havendo reembolso da Doação, conforme item 1.4.
            </Clause>

            <Clause> <b>1.7</b> - Cada período Vip é concedido somente à 1 único acesso, não sendo possível remanejar o período Vip corrente para outros acessos do usuário.
            </Clause>
            
            <Clause> <b>1.8</b> - O período Vip será ativado mediante a confirmação da Doação pela Provedora Responsável pelo pagamento.
            </Clause>

            <Clause> <b>1.9</b> - Caso o usuário não acesse o servidor durante seu período Vip, este será computado normalmente como dia de uso.
            </Clause>

            <Clause> <b>2.0</b> - O acesso ao servidor pode ser temporariamente interrompido em caso de manutenções e problemas técnicos, não sendo computado a utilização do dia Vip durante esses períodos.
            </Clause>

            <Clause> <b>Estando Ciente e Concordando com todas as regras acima</b>, prossiga para Doar e receber seu acesso Vip.
            </Clause>

            </RuleMaster>

            <CheckBoxContainer>
                <Input type="checkbox"
                onClick={(event) => rulesValidationCheck(event)}
                />
                <span> Li e estou de acordo com todas as regras e condições de Doação e acesso Vip.</span>
            </CheckBoxContainer>

            <ConfirmInput
                    color={submitButtonColor}
                    onClick={() => {
                        setPopMenuContent(<VipRequestForm />);
                        OpenPopMenu("AccessPopUp");
                        }
                    }
                    value="Prosseguir"
                    available={availableSubmit}
                    />

        </VipRequestMaster>

        <BgPopUp bgp={PopUpImg}/>
        </MasterContainer>
    )
}

export default VipRequestRules;

const VipRequestMaster = styled.div`
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    //border: solid 1px black;
    width: 700px;
    height: 700px;
    //box-shadow: 10px 10px 10px 0px black;
`

const TitleMaster = styled.div`
    width: 550px;
    //border: solid;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: justify;
    margin-bottom: 30px;

`

const RuleMaster = styled.fieldset`
    width: 550px;
    height: 400px;
    border: solid 1px black;
    padding: 20px;
    overflow: auto;
    margin-bottom: 30px;

`

const Legend = styled.legend`
    font-size: 24pt;
    font-weight: bold;

`

const Clause = styled.div`
    text-align: justify;
    margin-bottom: 10px;
`



const CheckBoxContainer = styled.div`
    width: 600px;
    //border: solid;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 30px;

`

const Input = styled.input`
    width: 25px;
    height: 25px;
`

const ConfirmInput = styled.input`
    padding: 10px 5px;
    width: 200px;
    margin: 30px 0;
    border-radius: 5px;
    font-size: 14pt;
    border: none;
    background-color: ${props => props.color};
    color: white;
    transition: .3s ease-in-out;
    text-align: center;
    pointer-events: ${props => props.available};

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.1;
    
    }
`

const BgPopUp = styled.div`
    background-image: url(${props => props.bgp});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 525px;
    height: 730px;
    //border: solid;

    @media(max-width: 1000px) {
      background-image: url('');
      width: 0px;
    }

`

const MasterContainer = styled.div`
    display: flex;
    border: solid 1px;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    height: 100%;
`